// extracted by mini-css-extract-plugin
export default {"wrapper":"input_wrapper__FWtd3","title":"input_title__7+Sn0","input":"input_input__23xip","inputError":"input_inputError__yKYk8","bulletPoint":"input_bulletPoint__ywYQO"};